const {
    MOBILE_DEVICE,
    TABLET_DEVICE,
    IOS_OS_NAME,
    ANDROID_OS_NAME
} = require('./constants');

/**
 * Checks if a given device type is a mobile device or not.
 * @param {String} deviceType The parsed ua parser device type.
 * @return {Boolean}
 */
const isMobile = (deviceType) => deviceType === MOBILE_DEVICE;

/**
 * Checks if a given device type is a touch device or not.
 * @param {String} deviceType The parsed ua parser device type.
 * @return {Boolean}
 */
const isTouch = (deviceType) => [MOBILE_DEVICE, TABLET_DEVICE].includes(deviceType);

/**
 * Checks if a given os name is considered as IOS.
 * @param {String} osName - the parsed os name.
 * @return {Boolean}
 */
const isIos = (osName) => osName === IOS_OS_NAME;

/**
 * Checks if a given os name is considered as Andorid os.
 * @param {String} osName - the parsed os name.
 * @return {Boolean}
 */
const isAndroid = (osName) => osName === ANDROID_OS_NAME;

module.exports = {
    isMobile,
    isTouch,
    isIos,
    isAndroid
};
